import { InjectionToken } from '@angular/core';

/**
 * Configuration for the shared chat module. Provided by the host application
 * (the standalone Cohelion.Chat.Angular bootstrapper, or cdp-client) through
 * {@link CsChatModule.forRoot}.
 */
export interface CsChatConfig {
	/** Base URL of the chat/assistant backend (e.g. the Cohelion.Mcp.Server endpoint). */
	apiUrl?: string;

	/**
	 * Optional Bearer token for the chat backend — the browser equivalent of the
	 * CLI's `SATS_TOKEN` env var. Sent as `Authorization: Bearer <token>`. Leave
	 * empty in Development (the server allows anonymous access there); when
	 * embedding <cs-chat> in cdp-client, prefer its existing auth interceptor.
	 */
	token?: string;

	/** Optional display title rendered in the chat header. */
	title?: string;
}

export const CS_CHAT_CONFIG = new InjectionToken<CsChatConfig>('CS_CHAT_CONFIG');

/**
 * Resolves a downloadable artifact id to its full URL, against the CURRENTLY active chat server.
 * Provided by the host app (backed by ChatService) so the artifact download chip uses the exact same
 * base as the SSE stream — honouring the IIS path base (e.g. `/ai`) and any attached remote instance.
 * When absent, the chip falls back to a root-relative `/api/chat/artifacts/{id}`.
 */
export const CS_CHAT_ARTIFACT_URL = new InjectionToken<(id: number) => string>('CS_CHAT_ARTIFACT_URL');
